"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateContentItem = void 0;
const generateContentItem = (content) => {
    return {
        id: content?.content_data?.sku ?? 'no-sku-view-content',
        name: content?.content_data?.name ?? 'no-name-view-content',
        type: 'product',
        sku: content?.content_data?.sku ?? 'no-sku-view-content',
        page_url: content?.content_data?.page_url ?? 'no-url-view-content',
        image_url: content?.content_data?.image_url ?? 'no-image-view-content',
        price: content?.content_data?.price ?? 0,
        original_price: content?.content_data?.original_price ?? 0,
        main_category: content?.content_data?.main_category ?? 'no-category-view-content',
        age_range: content?.content_data?.age_range ?? '',
        parent_item_id: content?.content_data?.parent_item_id ?? '',
        is_parent: content?.content_data?.is_parent ?? false,
    };
};
exports.generateContentItem = generateContentItem;
